import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './confirmAssociateParentDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import { ADD_PARENT } from '@/modules/API/parent/parentAssociationHandler'
import { useAuth } from '@/modules/context/AuthContext'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmAssociateParentDialogProps {
    open: boolean
    closeDialog: () => void
    name: string
    email: string
    isNanny: boolean
    refetchAllSuggest: () => void
}

const ConfirmAssociateParentDialog: FunctionComponent<ConfirmAssociateParentDialogProps> = ({
    open,
    closeDialog,
    name,
    email,
    isNanny,
    refetchAllSuggest
}) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [addParent] = useMutation(ADD_PARENT, {
        variables: {
            daycare_id: user?.currentDaycare?.id,
            email_parent: email,
            from_suggest: true
        },
        onCompleted: () => {
            showNotificationSuccess(t(isNanny ? 'addPublicSuccess' : 'addFamilySuccess'))

            refetchAllSuggest()

            closeDialog()
        },
        onError: () => {
            showNotificationError(t(isNanny ? 'addPublicError' : 'addFamilyError'))
        }
    })

    return (
        <Dialog open={open} handleClose={closeDialog} className={styles.DialogAdd}>
            <DialogHeader title={isNanny ? t('associateAssMat') : t('associateFamily')}></DialogHeader>
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('associateMessage')}</p>
                {user?.daycares && user?.daycares.length > 1 && (
                    <>
                        <p className={styles.Text}>
                            {user?.currentDaycare?.name} - {user?.currentDaycare?.city}
                        </p>
                        <br />
                    </>
                )}
                <p className={styles.TextFamily}>
                    {name} {email && `- ${email}`}
                </p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'cancel'} onClick={closeDialog} className={styles.Button} />
                    <ButtonTextIcon type={'confirm'} onClick={addParent} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmAssociateParentDialog
